var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBattery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 163,
    height: 122.25,
    viewBox: "0 0 163 122.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "battery",
    d: "M152.813,41.125H142.625V25.844a5.092,5.092,0,0,0-5.094-5.094H96.781a5.092,5.092,0,0,0-5.094,5.094V41.125H71.313V25.844a5.092,5.092,0,0,0-5.094-5.094H25.469a5.092,5.092,0,0,0-5.094,5.094V41.125H10.188A10.189,10.189,0,0,0,0,51.313v81.5A10.189,10.189,0,0,0,10.188,143H152.813A10.189,10.189,0,0,0,163,132.813v-81.5A10.189,10.189,0,0,0,152.813,41.125ZM101.875,30.938h30.563V41.125H101.875Zm-71.312,0H61.125V41.125H30.563Zm122.25,101.875H10.188v-81.5H152.813ZM134.984,81.875H122.25V69.141a2.546,2.546,0,0,0-2.547-2.547h-5.094a2.546,2.546,0,0,0-2.547,2.547V81.875H99.328a2.546,2.546,0,0,0-2.547,2.547v5.094a2.546,2.546,0,0,0,2.547,2.547h12.734V104.8a2.546,2.546,0,0,0,2.547,2.547H119.7a2.546,2.546,0,0,0,2.547-2.547V92.063h12.734a2.546,2.546,0,0,0,2.547-2.547V84.422A2.546,2.546,0,0,0,134.984,81.875Zm-71.312,0H28.016a2.546,2.546,0,0,0-2.547,2.547v5.094a2.546,2.546,0,0,0,2.547,2.547H63.672a2.546,2.546,0,0,0,2.547-2.547V84.422A2.546,2.546,0,0,0,63.672,81.875Z",
    transform: "translate(0 -20.75)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattery);
export default __webpack_public_path__ + "static/media/battery.7c3003e2fa3396bd483498581d47d57f.svg";
export { ForwardRef as ReactComponent };